import { render } from "./CreateShioriModal.vue?vue&type=template&id=3b864482&scoped=true"
import script from "./CreateShioriModal.vue?vue&type=script&lang=js"
export * from "./CreateShioriModal.vue?vue&type=script&lang=js"

import "./CreateShioriModal.vue?vue&type=style&index=0&id=3b864482&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b864482"]])

export default __exports__